export function onboardingTestActive(route) {
  const host = window.location.hostname || "";
  // Only allow this off-prod, but require the query param to be present
  const isSafeEnv =
    host.includes("localhost") ||
    host.includes("appstage") ||
    host.includes("appdev");
  if (!isSafeEnv) return false;

  return route?.query?.onboarding === "1";
}
